import { Box, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CampaginTable from '../../../common/CampaignTable';
import { CampaignContext } from '../../../../contexts/CampaignContext';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

const PackagesList = () => {
	let { fetchedMedias } = useContext(CampaignContext);
	let { t } = useTranslation();
	let navigate = useNavigate();
	const headerClassNames = 'text-xs bg-background-paper';
	let tabItem = [
		{
			api: '/admin/media-packages',
			postApi: '/admin/media-packages',
			system_name: 'campaign-release-time',
			label: 'add_chanels_packages',
			search: '',
			showBtn: true,
			clickAction: () => {
				navigate('/campaigns/add_chanels');
			},
			editAction: (id: number) => {
				navigate(`/campaigns/add_chanels/${id}`);
			},
			view: false,
			edit: true,
			delete: true,
			columns: [
				{ field: 'title', flex: 1, headerName: t('title'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{
					field: 'media',
					flex: 1,
					headerName: t('media'),
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
					renderCell: (params: any) => {
						let filterMedia = fetchedMedias?.find(item => item.system_name === params.row.media);
						return filterMedia?.title;
					},
				},
				{
					field: 'created_at',
					flex: 1,
					headerName: t('created_time'),
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
					renderCell: (params: any) => {
						return new Date(params.row.created_at).toLocaleDateString('fa-IR');
					},
				},
				{
					field: 'view_campaign',
					headerName: t('view_campaign'),
					flex: 2,
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => (
						<FormGroup className="flex flex-row items-center justify-center pt-2">
							<FormControlLabel control={<Checkbox checked={params.row.view_campaign} />} label={t('view')} />
							<FormControlLabel control={<Checkbox checked={params.row.reserve_campaign} />} label={t('reserve')} />
						</FormGroup>
					),
				},
				{
					field: 'is_active',
					headerName: t('status'),
					width: 150,
					flex: 1,
					display: 'flex',
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => {
						return <div className={`rounded-lg p-2.5 ${params.row.is_active ? 'bg-green-50 text-green-600' : 'bg-red-100 text-red-600'}`}>{params.row.is_active ? t('active') : t('inactive')}</div>;
					},
				},
			],
			route: 'campaigns/view',
		},
	];
	return (
		<Box className="w-full">
			<CampaginTable tabItem={tabItem[0]} />
		</Box>
	);
};
export default PackagesList;
